import checkResponseJSON from "./Fetch";

const NOOP = () => {};

function executeRecaptcha({ success = NOOP, fail = NOOP, always = NOOP } = {}) {
  const { grecaptcha } = window;

  function submitRecaptcha() {
    return fetch(`/recaptcha?g-recaptcha-response=${grecaptcha.getResponse()}`)
      .then(checkResponseJSON)
      .then(() => {
        success();
        window.submitRecaptcha = null;
      })
      .catch(fail)
      .finally(always);
  }

  if (grecaptcha && grecaptcha.execute) {
    window.submitRecaptcha = submitRecaptcha;

    grecaptcha.execute();
  }
}

export default executeRecaptcha;



// WEBPACK FOOTER //
// ./utils/Recaptcha.js